
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as plan3R30biafk6VKD_452dlOs4_45Mj2rn6l_45daVKp7gCfbVj0cMeta } from "/codebuild/output/src713373481/src/dashboard/pages/plan.vue?macro=true";
import { default as indexoGflBS_456K6el77_fJ5KT_45zY9DO70mlJYv4gaR_45Lk_1sMeta } from "/codebuild/output/src713373481/src/dashboard/pages/index.vue?macro=true";
import { default as startanPvJrkKXuUYpfukMDrz8efaBObRXuaSnCdsLvuiEmEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/start.vue?macro=true";
import { default as trial5f7vUJd3i1e0jA3CqNnvtLzXHRp2cjXfXiZK1ONmhrcMeta } from "/codebuild/output/src713373481/src/dashboard/pages/trial.vue?macro=true";
import { default as paynowunPJ_45eBWqtICyuVv6t9QFT9ZEiK2grNq4NzbClOq1icMeta } from "/codebuild/output/src713373481/src/dashboard/pages/paynow.vue?macro=true";
import { default as registerbNaWUqeT_oPiaxmrFIK7SaiLxjoT8_45v8oSSr9OXjIDwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/register.vue?macro=true";
import { default as _91id_9364g3ql_454ZHi9DkKYTjAKq6GSzPeuPxM4HK3ihBvh1QgMeta } from "/codebuild/output/src713373481/src/dashboard/pages/list/[id].vue?macro=true";
import { default as index2PFBITa3_45BxMARfMppyGmna27d_45Hi4BIP8sn3kzIrLQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/list/index.vue?macro=true";
import { default as indexTY9Eqj9nCHpioPPDnRszZXOi_OC7axuRYhORkqbTk0QMeta } from "/codebuild/output/src713373481/src/dashboard/pages/logs/index.vue?macro=true";
import { default as _91id_931WdZDcRPCzFN8lGXF0AleyWHi0Gi_45S_QDWROUZroH6UMeta } from "/codebuild/output/src713373481/src/dashboard/pages/events/[id].vue?macro=true";
import { default as indexa3DfEfd2D2sR_6gNBzikmL7tRXdNuXBvAVokp_451OSFoMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/index.vue?macro=true";
import { default as index8kd64Lp1VWzKmZkfvuDm6pAuC3j91unPZH8bgFYcJs0Meta } from "/codebuild/output/src713373481/src/dashboard/pages/events/index.vue?macro=true";
import { default as createYxo0Z04m3Tr4HsZ0TCGU39GGpNshhv_4590ykasVwOuZcMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/create.vue?macro=true";
import { default as createbbDUPlxDyQnCsaFzlsulo1_zg4aK_Ns6BkqnCjulXHsMeta } from "/codebuild/output/src713373481/src/dashboard/pages/events/create.vue?macro=true";
import { default as smsdnpiGMtwHERxPDAL9JB7MdNElbaRk_IoGt8yX7ddJCUMeta } from "/codebuild/output/src713373481/src/dashboard/pages/providers/sms.vue?macro=true";
import { default as indexQuswuERFfN4MGj8F1mSpbskDSqPpgK_5G6Cf2WOX2XgMeta } from "/codebuild/output/src713373481/src/dashboard/pages/customers/[id]/index.vue?macro=true";
import { default as attributes0xX8lpHMYXd59R_45UM4RpPwisBl7Dbnuvet3RZDOaiCoMeta } from "/codebuild/output/src713373481/src/dashboard/pages/customers/[id]/attributes.vue?macro=true";
import { default as _91id_93r2qIBx3SgLsJ3UkgoY4SSXrrU1P3_45mpy56UU19pF3HsMeta } from "/codebuild/output/src713373481/src/dashboard/pages/customers/[id].vue?macro=true";
import { default as indexP_MsjvbnFYiMcxjYv9lfLof8V9mC8YTHUsfRn_KY1h8Meta } from "/codebuild/output/src713373481/src/dashboard/pages/insights/index.vue?macro=true";
import { default as _91token_93bdt1WKdmyRx7wQf3OybMIHqQpKr2a7aNCs8KVV_eLOoMeta } from "/codebuild/output/src713373481/src/dashboard/pages/invite/[token].vue?macro=true";
import { default as resethOEoYD8OCaafB1JtafDLeXuxCmjpLzYCzmXCAnm2YZUMeta } from "/codebuild/output/src713373481/src/dashboard/pages/password/reset.vue?macro=true";
import { default as indexxXOd1vScgOacsDKTXpqtCU7inlZROqganCDmm0Km6goMeta } from "/codebuild/output/src713373481/src/dashboard/pages/segments/index.vue?macro=true";
import { default as indexrdQlh9GpcD45vyClz8HLr8r5FYSFawmRRJzqnvKIXb0Meta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/index.vue?macro=true";
import { default as index2YNHMnP6n9EbLQWcyRkegXxdzvPobtuUy8929rjnFSkMeta } from "/codebuild/output/src713373481/src/dashboard/pages/template/index.vue?macro=true";
import { default as startDSmU7WIhXwMdtthfPvrwRU7VpWPnLNKBtrYZhe_45eytQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/whatsapp/start.vue?macro=true";
import { default as payment76GJUlG19C_45XQvqN2VrwTNUVotM7cXrEipoXRCiqArwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/connect/payment.vue?macro=true";
import { default as indexodLLiaBpxsqagTJWbiv0606vviMDkFVUPH4XjA3dPdEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/customers/index.vue?macro=true";
import { default as index_bzvrkno65NX87HWt8SDr_I2ZOOtz8b55LOP2DKQansMeta } from "/codebuild/output/src713373481/src/dashboard/pages/dashboard/index.vue?macro=true";
import { default as indexj5dAU7vFmFs4qyJkRTtp1SuV_CPZkwMR0KElDSXhxAwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/one-inbox/index.vue?macro=true";
import { default as forgotB6B1nXqojGwY26B7Hiaxy0MdbFLPIYJxy2KSms2TXhgMeta } from "/codebuild/output/src713373481/src/dashboard/pages/password/forgot.vue?macro=true";
import { default as email0JY1KCfLMrkT4x3y_45kB9pdy2zy0LBKU7pPgaelTviCgMeta } from "/codebuild/output/src713373481/src/dashboard/pages/providers/email.vue?macro=true";
import { default as createzNfPrLrbyA1l_457knyJXD__45q1NZrEJRUGsZxpZ_45KaD2YMeta } from "/codebuild/output/src713373481/src/dashboard/pages/segments/create.vue?macro=true";
import { default as index5dMvvyax5d_453CrelYid297AMoJa_45uHMTfK_45rTM5XYaEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/attributes/index.vue?macro=true";
import { default as logscORishP_p0zcIF_rwJCVCe5riA42EtrcNGQwoCN_ueEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/automations/logs.vue?macro=true";
import { default as importZAgN9op9zIdzXVkszTcr4ANZfoavaAoO8ImQ_5sE194Meta } from "/codebuild/output/src713373481/src/dashboard/pages/customers/import.vue?macro=true";
import { default as edit_45_91id_93bi7nD_45zjO_RWkpfKbkQi47whD4VQz59eqPCBFbjrk7EMeta } from "/codebuild/output/src713373481/src/dashboard/pages/events/edit-[id].vue?macro=true";
import { default as indexL6I9aCOUdrwFnx_45H_jM9Yy4qEoxUJAqlfAikXgdSYP4Meta } from "/codebuild/output/src713373481/src/dashboard/pages/onboarding/index.vue?macro=true";
import { default as builderkc5kz_omm2aSbwKXxQUZSxQY9CMQeoxgJ6EA_Hs_5i0Meta } from "/codebuild/output/src713373481/src/dashboard/pages/template/builder.vue?macro=true";
import { default as createxEc7RPLwRHzFbi9KQVIXtL75HFDlR3o9Rt_YeEicjQ4Meta } from "/codebuild/output/src713373481/src/dashboard/pages/attributes/create.vue?macro=true";
import { default as indexrNkH_45HaIiKDyFJ_il2o8rji2jZNns7OReAnVudrk4c4Meta } from "/codebuild/output/src713373481/src/dashboard/pages/automations/index.vue?macro=true";
import { default as auditf2_fVGn4oF_45vivd1ucK8tlh655UvylpF8_XQi1_PtZkMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/audit.vue?macro=true";
import { default as paymentWhH_7ODWVamRZ8oNhjVzPzhiSof9SrVxYgSmqLVtblwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/providers/payment.vue?macro=true";
import { default as report8_bAh4cxoragnBHhGoBQfCS_45_43AvNxUV8yCx_mMepEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/report.vue?macro=true";
import { default as ruleevim0GVO7zhYljl71sVlMcA7I3imcb4025yqYdaHR5QMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/rule.vue?macro=true";
import { default as indexiSHproYUANfG1AIGeTNNcVmbWuJdU4TSFMN75SolEzwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/index.vue?macro=true";
import { default as orders_qwoLfaQ_45ZBFrK19rgaeVkYel0O9DHaIjVXDMiFeZ2QMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/orders.vue?macro=true";
import { default as deliveryywyFiT2K3pclOf1rDc2HR9gK8YScybEDlGtHQtASvlQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/delivery.vue?macro=true";
import { default as productsyHkEOPy1Cqn4ytn7NajqflHHoGk7DrC_5Ex3OXH_45qhMMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/products.vue?macro=true";
import { default as customizemQCJG0NLyQy_45X4CNSyTQ12rqE876v6zKwXU_45gKJQo5oMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/customize.vue?macro=true";
import { default as _91id_93KXk8epn5FfMIC_biFVVS727HsusP6NbeOZ2tmaPVpv4Meta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id].vue?macro=true";
import { default as customersgm13rKwNo955HuIS5yi5FubMBi1_45CgxvLV7uYxCoBlUMeta } from "/codebuild/output/src713373481/src/dashboard/pages/segments/customers.vue?macro=true";
import { default as edittMdqU8rBSfXk2UKP61JOdZypz35V912HFe0s35rDK_458Meta } from "/codebuild/output/src713373481/src/dashboard/pages/template/[id]/edit.vue?macro=true";
import { default as indexeAe_45mC_407LlHQAL820y8_45MN4x97GkAKi_45SHOM8A_456IMeta } from "/codebuild/output/src713373481/src/dashboard/pages/transactions/index.vue?macro=true";
import { default as indexvCgEdUpdHlyPmjV_hUsowIwJaJnwTlOQjEHEenfNtTMMeta } from "/codebuild/output/src713373481/src/dashboard/pages/account-setup/index.vue?macro=true";
import { default as accountsiIIzqTLmBEIFxCT9YO4_qHGeAAM_45htKA4tpYQUJ38rIMeta } from "/codebuild/output/src713373481/src/dashboard/pages/collection/accounts.vue?macro=true";
import { default as listA26313ufr0dgUyMvISNKDKljLhQCkO1sX8mEU71OW0UMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-events/list.vue?macro=true";
import { default as index4Untae0nZHN_455rmdn7f3n_45OGnvoRef_E8RjlsbTb7hQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/index.vue?macro=true";
import { default as links64nfT5fJz6_EuIn4rEISCfp8UpHpg3syunyMcoT5eWIMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/links.vue?macro=true";
import { default as _91action_93U4G6CN_CPgdxwmznVBeIUWkVAZjTabeezskQXmBsdPMMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/[action].vue?macro=true";
import { default as accountingnecwpn4NtrPuxgvpLG66HSUAMh63_45LntqxugZk5jHDEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/providers/accounting.vue?macro=true";
import { default as indexr4fYoJNFFsWbEBRr_45p9qG_PqfuYTtO6WPd_45UnxsPR8MMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/teams/index.vue?macro=true";
import { default as indexZu1rW_6og3Gy5NovX_455cBiR43HNTmB4rUb6k__45M2WhAMeta } from "/codebuild/output/src713373481/src/dashboard/pages/attributes/[id]/index.vue?macro=true";
import { default as indexhpRT_HtfrC_9AMcBbpxsSSx2f5_45Yb8iRKZlv58phWygMeta } from "/codebuild/output/src713373481/src/dashboard/pages/custom-messages/index.vue?macro=true";
import { default as indexdEQOa7GJnW_NCHDn_HuO7s8ZqtPczmCL7Z9qjoxn444Meta } from "/codebuild/output/src713373481/src/dashboard/pages/segments/cohort/index.vue?macro=true";
import { default as index_45_45NUgPLjHIsAOZ_45NPSCD3mivhWv9m9t8njRCefOov3QMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/domain/index.vue?macro=true";
import { default as indexgB5bBM5UFdAwNpdspPk7CJOmfn6yU7JnkX1WAC2gZ70Meta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/index.vue?macro=true";
import { default as _91type_93Tnp6JAQsRvsO_RZsNK_45Ofapwamm9PfoV0PySmDBPRIQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/[type].vue?macro=true";
import { default as zohoyetv95mI6iwaTvJHPHiItDQYE8I3aPKmkU55UufpDncMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/integrate/zoho.vue?macro=true";
import { default as _91type_93efG_45XpBd2sNcUnS5qTIY3eth5loN39_9cSYMmvUy_45_UMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/channels/[type].vue?macro=true";
import { default as _91type_93Ti9azQhRETjQVV8Oq2HDggueE1z5iVRwYNr4EwZbz4cMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/data-source/[type].vue?macro=true";
import { default as firebasegpzx_E8O3ISk5uEYFWcN9LmX4vXtQzav2KKXXraUYv0Meta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/notifications/firebase.vue?macro=true";
import { default as integrationsJdyHJ1CeHSv_DXGzZQg_61uT97_453sgOv4V65gFq5trcMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/integrations.vue?macro=true";
import { default as indexaLNXhZ6thnU736wcTRQdvADTqr23X1_FU8m1MwiG1pYMeta } from "/codebuild/output/src713373481/src/dashboard/pages/complete-profile/index.vue?macro=true";
import { default as _91id_93Y593063lfZzWAjGO9jMrXDfBJ4HZxavuz51HfOaAFwwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/broadcasts/[id].vue?macro=true";
import { default as plansfIxa54TXTzWhModw0t3v0twnsOoatRxh2Lp2A_451keKwMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/billing/plans.vue?macro=true";
import { default as indexLJGLlS_45UpQGyPWe3rEmxgaxFt_qabJE_45o2lAEBlkJJIMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/profile/index.vue?macro=true";
import { default as indexukNnrESFlixMdWAp95XfL3wzI9cxqrUIzMT1_k00a7wMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/reports/index.vue?macro=true";
import { default as indexK_Bi7LCF_o1vrvbuo3SduUovgS7oHlItvO2uqfIIuvsMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/broadcasts/index.vue?macro=true";
import { default as addonstZ2v6tidbsB5_w9JNxmoGgznR_45cPUNJB61i3S65e37UMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/billing/addons.vue?macro=true";
import { default as indexkgDvBDbSLAoUMtuNj56Vep_aw7OvD1dqxRM9z_MCi6UMeta } from "/codebuild/output/src713373481/src/dashboard/pages/email-verification/index.vue?macro=true";
import { default as indexaZmADagZQrnQladS7DLiRd_nwtfChZzcH_45aip_5QcC8Meta } from "/codebuild/output/src713373481/src/dashboard/pages/segments/[segment]/index.vue?macro=true";
import { default as indexm18z6ge4G3ScbPE5Uch0mRsULjigd1ZMLa3FKygBWAgMeta } from "/codebuild/output/src713373481/src/dashboard/pages/whatsapp/templates/index.vue?macro=true";
import { default as createTdzQeTkybUu4Mt6M_45t70FjSkf5dd1wRbhnWvCWjlDyYMeta } from "/codebuild/output/src713373481/src/dashboard/pages/whatsapp/templates/create.vue?macro=true";
import { default as _91_91source_93_93fQflGm76x9YV0w_JUP2NIWp0mqNnoovXyQ8kwIGZdGoMeta } from "/codebuild/output/src713373481/src/dashboard/pages/segments/cohort/[[source]].vue?macro=true";
import { default as indexPwxiH9ZITc04Q8LRiRiLKo1FaV4ynfFUwBYZqAibdjMMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/api-webhook/index.vue?macro=true";
import { default as indexYHBFVb79L6Le6fWJ_2glWji00QUtr7wlGp0FaN3slQ8Meta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/index.vue?macro=true";
import { default as customize3ilbQXEbEETbnj8MCVH6B07Me5jRGR7ltZiesovoLbYMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/customize.vue?macro=true";
import { default as downloadsSec_45Dj_453Fx4HQbVNX62xhDSsMbZ_DFstoqDS980f2ckMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/downloads.vue?macro=true";
import { default as after_45paymentCTt3zJPIMZfKPS16r4zZLH9DxLbomo_45sSqHz3BA8VBAMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/after-payment.vue?macro=true";
import { default as _91id_93b9cv58nsKIzez_cOcEMDcPxGZZCKbeXZT11u33sKCykMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id].vue?macro=true";
import { default as workflow_45previewgs_45D1Pm9hUHNoHP14_jXOgg86_450QJpvN3r86a_MKqy8Meta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/workflow-preview.vue?macro=true";
import { default as index8p6YHohObgM7Ho7cSS52ycp_oza_45w59aWEKddqeiVXEMeta } from "/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/index.vue?macro=true";
import { default as indextgvwmkqWb6SINF09MFo2mUuQjT4yrItGHzt7YF4rVcMMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/customer-data/index.vue?macro=true";
import { default as _91_91provider_93_939yH_RNNdpb_nLWDv93c3M7wvD2yoRrq7gedkhd3MiPYMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/wallet/[[provider]].vue?macro=true";
import { default as edit33H5D6AgwL5z_J9D8wuJrKMOrExobsuA3lOR0C_450J0kMeta } from "/codebuild/output/src713373481/src/dashboard/pages/whatsapp/templates/[id]/edit.vue?macro=true";
import { default as indexs6azOzk8w3_AZ3hdzxnlU_45Kf2DyqwPbdzI02Zco9NZIMeta } from "/codebuild/output/src713373481/src/dashboard/pages/collect-payment/invoice/index.vue?macro=true";
import { default as _91_91provider_93_931iBe6vNjdyRw6zShn1kGJO1xqs9qJAOAxmNpLySns7oMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/billing/[[provider]].vue?macro=true";
import { default as _91token_93ntqwxQegMbr5vU22fUIN7IfPaH0v_45rClRSgYaSxDTx8Meta } from "/codebuild/output/src713373481/src/dashboard/pages/[channel]/subscription/[token].vue?macro=true";
import { default as indexHftKFHYUgexDCdII8fHepPlL8GsNorG9itEO1xFLS7UMeta } from "/codebuild/output/src713373481/src/dashboard/pages/collect-payment/recieved/index.vue?macro=true";
import { default as _91message_935ocWJT3NHiOB7L9roMy5r9OAwAFzJuwJKFok3IwPWRgMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/messages/[message].vue?macro=true";
import { default as _91id_932h2my0zEZngYESGIHvPRaqt4fs_452P8Zj8ftcOPgbcZQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/broadcasts/details/[id].vue?macro=true";
import { default as _91id_93Z63DCn0sIJH0WqXXd5T5oT67i1HdPCGg6beMn_9p_45cMMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/roles-permission/[id].vue?macro=true";
import { default as indexK5nG5kK1UAh4rKLJzXElJAvT_gQiq6zD3Qc4kpK2G5oMeta } from "/codebuild/output/src713373481/src/dashboard/pages/collect-payment/reconcile/index.vue?macro=true";
import { default as index_45swHJztWbTwKBqtowZbzcZt4ZyNFqFpEWwFKWy_mZlcMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/roles-permission/index.vue?macro=true";
import { default as createXlFPKM7aA21i6BmEVDsOaLe1K74_745kyDVhenJf3iQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/settings/roles-permission/create.vue?macro=true";
import { default as previewH_45BTIe_45YhpkqT8NuDXLdK3U6p3Umve8QNYr_AOe8J9wMeta } from "/codebuild/output/src713373481/src/dashboard/pages/collect-payment/invoice/[id]/preview.vue?macro=true";
import { default as callbackWPvxWVECVEQb_45lq1IfJCMjAW3zSz_6OgLgYzK0uFjbQMeta } from "/codebuild/output/src713373481/src/dashboard/pages/integrations/zoho/[company]/callback.vue?macro=true";
import { default as create5qni3K4cxXj4k_45lrc1CQb9gLy_45H78y0akIofbnq3dJAMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/transactional/templates/create.vue?macro=true";
import { default as send_45reminderPk0lt8_459Yyi__456qNt0QF5CAIqThLzcYkGN50o_8gnq4Meta } from "/codebuild/output/src713373481/src/dashboard/pages/collect-payment/reconcile/[id]/send-reminder.vue?macro=true";
import { default as _91version_93rKee41LIuAEQg2fU6gudwOPI_454F4w07jolgaUuFGKNAMeta } from "/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/workflow-version-preview/[version].vue?macro=true";
export default [
  {
    name: "plan",
    path: "/plan",
    meta: { ...(plan3R30biafk6VKD_452dlOs4_45Mj2rn6l_45daVKp7gCfbVj0cMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/plan.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexoGflBS_456K6el77_fJ5KT_45zY9DO70mlJYv4gaR_45Lk_1sMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/index.vue")
  },
  {
    name: "start",
    path: "/start",
    meta: { ...(startanPvJrkKXuUYpfukMDrz8efaBObRXuaSnCdsLvuiEmEMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/start.vue")
  },
  {
    name: "trial",
    path: "/trial",
    meta: { ...(trial5f7vUJd3i1e0jA3CqNnvtLzXHRp2cjXfXiZK1ONmhrcMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/trial.vue")
  },
  {
    name: "paynow",
    path: "/paynow",
    meta: { ...(paynowunPJ_45eBWqtICyuVv6t9QFT9ZEiK2grNq4NzbClOq1icMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/paynow.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerbNaWUqeT_oPiaxmrFIK7SaiLxjoT8_45v8oSSr9OXjIDwMeta || {}), ...{"middleware":["is-enterprise"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/register.vue")
  },
  {
    name: _91id_9364g3ql_454ZHi9DkKYTjAKq6GSzPeuPxM4HK3ihBvh1QgMeta?.name ?? "list-id",
    path: "/list/:id()",
    meta: { ...(_91id_9364g3ql_454ZHi9DkKYTjAKq6GSzPeuPxM4HK3ihBvh1QgMeta || {}), ...{"middleware":["auth","email-verified","onboarding-completed"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/list/[id].vue")
  },
  {
    name: index2PFBITa3_45BxMARfMppyGmna27d_45Hi4BIP8sn3kzIrLQMeta?.name ?? "list",
    path: "/list",
    meta: { ...(index2PFBITa3_45BxMARfMppyGmna27d_45Hi4BIP8sn3kzIrLQMeta || {}), ...{"middleware":["auth","email-verified","onboarding-completed","has-a-plan"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/list/index.vue")
  },
  {
    name: "logs",
    path: "/logs",
    meta: { ...(indexTY9Eqj9nCHpioPPDnRszZXOi_OC7axuRYhORkqbTk0QMeta || {}), ...{"middleware":["auth","email-verified","has-a-plan"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/logs/index.vue")
  },
  {
    name: "events-id",
    path: "/events/:id()",
    meta: { ...(_91id_931WdZDcRPCzFN8lGXF0AleyWHi0Gi_45S_QDWROUZroH6UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/events/[id].vue")
  },
  {
    name: "engage",
    path: "/engage",
    meta: {"middleware":["auth","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/index.vue")
  },
  {
    name: "Events",
    path: "/events",
    meta: { ...(index8kd64Lp1VWzKmZkfvuDm6pAuC3j91unPZH8bgFYcJs0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/events/index.vue")
  },
  {
    name: "engage-create",
    path: "/engage/create",
    meta: createYxo0Z04m3Tr4HsZ0TCGU39GGpNshhv_4590ykasVwOuZcMeta || {},
    redirect: "/engage/create/create",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/create.vue")
  },
  {
    name: "events-create",
    path: "/events/create",
    meta: { ...(createbbDUPlxDyQnCsaFzlsulo1_zg4aK_Ns6BkqnCjulXHsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/events/create.vue")
  },
  {
    name: "providers-sms",
    path: "/providers/sms",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/providers/sms.vue")
  },
  {
    name: _91id_93r2qIBx3SgLsJ3UkgoY4SSXrrU1P3_45mpy56UU19pF3HsMeta?.name,
    path: "/customers/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/customers/[id].vue"),
    children: [
  {
    name: "CustomerProfile",
    path: "",
    meta: indexQuswuERFfN4MGj8F1mSpbskDSqPpgK_5G6Cf2WOX2XgMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/customers/[id]/index.vue")
  },
  {
    name: "CustomerAttributes",
    path: "attributes",
    meta: attributes0xX8lpHMYXd59R_45UM4RpPwisBl7Dbnuvet3RZDOaiCoMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/customers/[id]/attributes.vue")
  }
]
  },
  {
    name: "insights",
    path: "/insights",
    meta: { ...(indexP_MsjvbnFYiMcxjYv9lfLof8V9mC8YTHUsfRn_KY1h8Meta || {}), ...{"middleware":["auth","email-verified","onboarding-completed","has-a-plan"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/insights/index.vue")
  },
  {
    name: "invite-token",
    path: "/invite/:token()",
    meta: _91token_93bdt1WKdmyRx7wQf3OybMIHqQpKr2a7aNCs8KVV_eLOoMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/invite/[token].vue")
  },
  {
    name: "password-reset",
    path: "/password/reset",
    meta: resethOEoYD8OCaafB1JtafDLeXuxCmjpLzYCzmXCAnm2YZUMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/password/reset.vue")
  },
  {
    name: "segments",
    path: "/segments",
    meta: {"middleware":["auth","email-verified","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/segments/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexrdQlh9GpcD45vyClz8HLr8r5FYSFawmRRJzqnvKIXb0Meta || {},
    redirect: {"path":"/settings/profile","replace":true},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/index.vue")
  },
  {
    name: "template",
    path: "/template",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/template/index.vue")
  },
  {
    name: "whatsapp-start",
    path: "/whatsapp/start",
    meta: { ...(startDSmU7WIhXwMdtthfPvrwRU7VpWPnLNKBtrYZhe_45eytQMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/whatsapp/start.vue")
  },
  {
    name: "connect-payment",
    path: "/connect/payment",
    meta: {"middleware":["auth","email-verified"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/connect/payment.vue")
  },
  {
    name: "customers",
    path: "/customers",
    meta: { ...(indexodLLiaBpxsqagTJWbiv0606vviMDkFVUPH4XjA3dPdEMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/customers/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(index_bzvrkno65NX87HWt8SDr_I2ZOOtz8b55LOP2DKQansMeta || {}), ...{"middleware":["eager-load-session","auth","email-verified","has-a-plan","onboarding-completed"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/dashboard/index.vue")
  },
  {
    name: "one-inbox",
    path: "/one-inbox",
    meta: { ...(indexj5dAU7vFmFs4qyJkRTtp1SuV_CPZkwMR0KElDSXhxAwMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/one-inbox/index.vue")
  },
  {
    name: "password-forgot",
    path: "/password/forgot",
    meta: forgotB6B1nXqojGwY26B7Hiaxy0MdbFLPIYJxy2KSms2TXhgMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/password/forgot.vue")
  },
  {
    name: "providers-email",
    path: "/providers/email",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/providers/email.vue")
  },
  {
    name: "segments-create",
    path: "/segments/create",
    meta: {"middleware":["auth","email-verified","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/segments/create.vue")
  },
  {
    name: "attributes",
    path: "/attributes",
    meta: { ...(index5dMvvyax5d_453CrelYid297AMoJa_45uHMTfK_45rTM5XYaEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/attributes/index.vue")
  },
  {
    name: logscORishP_p0zcIF_rwJCVCe5riA42EtrcNGQwoCN_ueEMeta?.name ?? "automations-logs",
    path: "/automations/logs",
    meta: logscORishP_p0zcIF_rwJCVCe5riA42EtrcNGQwoCN_ueEMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/automations/logs.vue")
  },
  {
    name: "customers-import",
    path: "/customers/import",
    meta: { ...(importZAgN9op9zIdzXVkszTcr4ANZfoavaAoO8ImQ_5sE194Meta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/customers/import.vue")
  },
  {
    name: "events-edit-id",
    path: "/events/edit-:id()",
    meta: { ...(edit_45_91id_93bi7nD_45zjO_RWkpfKbkQi47whD4VQz59eqPCBFbjrk7EMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/events/edit-[id].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: { ...(indexL6I9aCOUdrwFnx_45H_jM9Yy4qEoxUJAqlfAikXgdSYP4Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/onboarding/index.vue")
  },
  {
    name: "template-builder",
    path: "/template/builder",
    meta: { ...(builderkc5kz_omm2aSbwKXxQUZSxQY9CMQeoxgJ6EA_Hs_5i0Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/template/builder.vue")
  },
  {
    name: "attributes-create",
    path: "/attributes/create",
    meta: { ...(createxEc7RPLwRHzFbi9KQVIXtL75HFDlR3o9Rt_YeEicjQ4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/attributes/create.vue")
  },
  {
    name: indexrNkH_45HaIiKDyFJ_il2o8rji2jZNns7OReAnVudrk4c4Meta?.name ?? "automations",
    path: "/automations",
    meta: indexrNkH_45HaIiKDyFJ_il2o8rji2jZNns7OReAnVudrk4c4Meta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/automations/index.vue")
  },
  {
    name: "engage-id-audit",
    path: "/engage/:id()/audit",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/audit.vue")
  },
  {
    name: "providers-payment",
    path: "/providers/payment",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/providers/payment.vue")
  },
  {
    name: "engage-id-report",
    path: "/engage/:id()/report",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/report.vue")
  },
  {
    name: _91id_93KXk8epn5FfMIC_biFVVS727HsusP6NbeOZ2tmaPVpv4Meta?.name,
    path: "/payment-links/:id()",
    meta: {"middleware":["auth","email-verified"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id].vue"),
    children: [
  {
    name: "payment-links-id-rule",
    path: "rule",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/rule.vue")
  },
  {
    name: "payment-links-id",
    path: "",
    meta: indexiSHproYUANfG1AIGeTNNcVmbWuJdU4TSFMN75SolEzwMeta || {},
    redirect: indexiSHproYUANfG1AIGeTNNcVmbWuJdU4TSFMN75SolEzwMeta?.redirect,
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/index.vue")
  },
  {
    name: "payment-links-id-orders",
    path: "orders",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/orders.vue")
  },
  {
    name: "payment-links-id-delivery",
    path: "delivery",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/delivery.vue")
  },
  {
    name: "SinglePaymentLinkProducts",
    path: "products",
    meta: { ...(productsyHkEOPy1Cqn4ytn7NajqflHHoGk7DrC_5Ex3OXH_45qhMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/products.vue")
  },
  {
    name: "payment-links-id-customize",
    path: "customize",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/[id]/customize.vue")
  }
]
  },
  {
    name: customersgm13rKwNo955HuIS5yi5FubMBi1_45CgxvLV7uYxCoBlUMeta?.name ?? "segments-customers",
    path: "/segments/customers",
    meta: { ...(customersgm13rKwNo955HuIS5yi5FubMBi1_45CgxvLV7uYxCoBlUMeta || {}), ...{"middleware":["auth","email-verified","has-a-plan"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/segments/customers.vue")
  },
  {
    name: "template-id-edit",
    path: "/template/:id()/edit",
    meta: { ...(edittMdqU8rBSfXk2UKP61JOdZypz35V912HFe0s35rDK_458Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/template/[id]/edit.vue")
  },
  {
    name: "Transactions",
    path: "/transactions",
    meta: { ...(indexeAe_45mC_407LlHQAL820y8_45MN4x97GkAKi_45SHOM8A_456IMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/transactions/index.vue")
  },
  {
    name: "account-setup",
    path: "/account-setup",
    meta: {"middleware":["auth","email-verified","onboarding-completed"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/account-setup/index.vue")
  },
  {
    name: accountsiIIzqTLmBEIFxCT9YO4_qHGeAAM_45htKA4tpYQUJ38rIMeta?.name ?? "collection-accounts",
    path: "/collection/accounts",
    meta: accountsiIIzqTLmBEIFxCT9YO4_qHGeAAM_45htKA4tpYQUJ38rIMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/collection/accounts.vue")
  },
  {
    name: "PaymentEvents",
    path: "/payment-events/list",
    meta: { ...(listA26313ufr0dgUyMvISNKDKljLhQCkO1sX8mEU71OW0UMeta || {}), ...{"middleware":["auth","has-a-plan"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-events/list.vue")
  },
  {
    name: "payment-links",
    path: "/payment-links",
    meta: index4Untae0nZHN_455rmdn7f3n_45OGnvoRef_E8RjlsbTb7hQMeta || {},
    redirect: {"replace":true,"path":"/payment-links/links"},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/index.vue")
  },
  {
    name: "PaymentLinksList",
    path: "/payment-links/links",
    meta: { ...(links64nfT5fJz6_EuIn4rEISCfp8UpHpg3syunyMcoT5eWIMeta || {}), ...{"middleware":["auth","email-verified","onboarding-completed"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/links.vue")
  },
  {
    name: "engage-id-action",
    path: "/engage/:id()/:action()",
    meta: {"middleware":["auth","email-verified"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/[action].vue")
  },
  {
    name: "providers-accounting",
    path: "/providers/accounting",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/providers/accounting.vue")
  },
  {
    name: "settings-teams",
    path: "/settings/teams",
    meta: { ...(indexr4fYoJNFFsWbEBRr_45p9qG_PqfuYTtO6WPd_45UnxsPR8MMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/teams/index.vue")
  },
  {
    name: "attributes-id",
    path: "/attributes/:id()",
    meta: { ...(indexZu1rW_6og3Gy5NovX_455cBiR43HNTmB4rUb6k__45M2WhAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/attributes/[id]/index.vue")
  },
  {
    name: indexhpRT_HtfrC_9AMcBbpxsSSx2f5_45Yb8iRKZlv58phWygMeta?.name ?? "custom-messages",
    path: "/custom-messages",
    meta: indexhpRT_HtfrC_9AMcBbpxsSSx2f5_45Yb8iRKZlv58phWygMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/custom-messages/index.vue")
  },
  {
    name: "CohortAnalytics",
    path: "/segments/cohort",
    meta: indexdEQOa7GJnW_NCHDn_HuO7s8ZqtPczmCL7Z9qjoxn444Meta || {},
    redirect: indexdEQOa7GJnW_NCHDn_HuO7s8ZqtPczmCL7Z9qjoxn444Meta?.redirect,
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/segments/cohort/index.vue")
  },
  {
    name: "settings-domain",
    path: "/settings/domain",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/domain/index.vue")
  },
  {
    name: integrationsJdyHJ1CeHSv_DXGzZQg_61uT97_453sgOv4V65gFq5trcMeta?.name,
    path: "/settings/integrations",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations.vue"),
    children: [
  {
    name: "settings-integrations",
    path: "",
    meta: indexgB5bBM5UFdAwNpdspPk7CJOmfn6yU7JnkX1WAC2gZ70Meta || {},
    redirect: indexgB5bBM5UFdAwNpdspPk7CJOmfn6yU7JnkX1WAC2gZ70Meta?.redirect,
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/index.vue")
  },
  {
    name: "settings-integrations-type",
    path: ":type()",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/[type].vue")
  },
  {
    name: "SettingsIntegrateZoho",
    path: "integrate/zoho",
    meta: { ...(zohoyetv95mI6iwaTvJHPHiItDQYE8I3aPKmkU55UufpDncMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/integrate/zoho.vue")
  },
  {
    name: "settings-integrations-channels-type",
    path: "channels/:type()",
    meta: { ...(_91type_93efG_45XpBd2sNcUnS5qTIY3eth5loN39_9cSYMmvUy_45_UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/channels/[type].vue")
  },
  {
    name: "settings-integrations-data-source-type",
    path: "data-source/:type()",
    meta: { ...(_91type_93Ti9azQhRETjQVV8Oq2HDggueE1z5iVRwYNr4EwZbz4cMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/data-source/[type].vue")
  },
  {
    name: "SettingsIntegrationFirebase",
    path: "notifications/firebase",
    meta: { ...(firebasegpzx_E8O3ISk5uEYFWcN9LmX4vXtQzav2KKXXraUYv0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/integrations/notifications/firebase.vue")
  }
]
  },
  {
    name: "complete-profile",
    path: "/complete-profile",
    meta: { ...(indexaLNXhZ6thnU736wcTRQdvADTqr23X1_FU8m1MwiG1pYMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/complete-profile/index.vue")
  },
  {
    name: "engage-broadcasts-id",
    path: "/engage/broadcasts/:id()",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/broadcasts/[id].vue")
  },
  {
    name: "settings-billing-plans",
    path: "/settings/billing/plans",
    meta: {"middleware":["auth","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/billing/plans.vue")
  },
  {
    name: "settings-profile",
    path: "/settings/profile",
    meta: { ...(indexLJGLlS_45UpQGyPWe3rEmxgaxFt_qabJE_45o2lAEBlkJJIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/profile/index.vue")
  },
  {
    name: "settings-reports",
    path: "/settings/reports",
    meta: { ...(indexukNnrESFlixMdWAp95XfL3wzI9cxqrUIzMT1_k00a7wMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/reports/index.vue")
  },
  {
    name: "engage-broadcasts",
    path: "/engage/broadcasts",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/broadcasts/index.vue")
  },
  {
    name: "settings-billing-addons",
    path: "/settings/billing/addons",
    meta: {"middleware":["auth","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/billing/addons.vue")
  },
  {
    name: "email-verification",
    path: "/email-verification",
    meta: { ...(indexkgDvBDbSLAoUMtuNj56Vep_aw7OvD1dqxRM9z_MCi6UMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/email-verification/index.vue")
  },
  {
    name: "segments-segment",
    path: "/segments/:segment()",
    meta: {"middleware":["auth","email-verified","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/segments/[segment]/index.vue")
  },
  {
    name: "whatsapp-templates",
    path: "/whatsapp/templates",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/whatsapp/templates/index.vue")
  },
  {
    name: "whatsapp-templates-create",
    path: "/whatsapp/templates/create",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/whatsapp/templates/create.vue")
  },
  {
    name: "CohortAnalyticsView",
    path: "/segments/cohort/:source?",
    meta: { ...(_91_91source_93_93fQflGm76x9YV0w_JUP2NIWp0mqNnoovXyQ8kwIGZdGoMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/segments/cohort/[[source]].vue")
  },
  {
    name: "settings-api-webhook",
    path: "/settings/api-webhook",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/api-webhook/index.vue")
  },
  {
    name: _91id_93b9cv58nsKIzez_cOcEMDcPxGZZCKbeXZT11u33sKCykMeta?.name,
    path: "/payment-links/products/:id()",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id].vue"),
    children: [
  {
    name: "payment-links-products-id",
    path: "",
    meta: indexYHBFVb79L6Le6fWJ_2glWji00QUtr7wlGp0FaN3slQ8Meta || {},
    redirect: indexYHBFVb79L6Le6fWJ_2glWji00QUtr7wlGp0FaN3slQ8Meta?.redirect,
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/index.vue")
  },
  {
    name: "PaymentLinkProductCustomize",
    path: "customize",
    meta: customize3ilbQXEbEETbnj8MCVH6B07Me5jRGR7ltZiesovoLbYMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/customize.vue")
  },
  {
    name: "PaymentLinkProductDownloads",
    path: "downloads",
    meta: downloadsSec_45Dj_453Fx4HQbVNX62xhDSsMbZ_DFstoqDS980f2ckMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/downloads.vue")
  },
  {
    name: "PaymentLinkProductAfterPaymentRule",
    path: "after-payment",
    meta: after_45paymentCTt3zJPIMZfKPS16r4zZLH9DxLbomo_45sSqHz3BA8VBAMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/[id]/after-payment.vue")
  }
]
  },
  {
    name: "engage-id-workflow-preview",
    path: "/engage/:id()/workflow-preview",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/workflow-preview.vue")
  },
  {
    name: "AllProducts",
    path: "/payment-links/products",
    meta: { ...(index8p6YHohObgM7Ho7cSS52ycp_oza_45w59aWEKddqeiVXEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/payment-links/products/index.vue")
  },
  {
    name: "settings-customer-data",
    path: "/settings/customer-data",
    meta: {"middleware":["auth","admin-only"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/customer-data/index.vue")
  },
  {
    name: "settings-wallet-provider",
    path: "/settings/wallet/:provider?",
    meta: { ...(_91_91provider_93_939yH_RNNdpb_nLWDv93c3M7wvD2yoRrq7gedkhd3MiPYMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/wallet/[[provider]].vue")
  },
  {
    name: "whatsapp-templates-id-edit",
    path: "/whatsapp/templates/:id()/edit",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/whatsapp/templates/[id]/edit.vue")
  },
  {
    name: "collect-payment-invoice",
    path: "/collect-payment/invoice",
    meta: { ...(indexs6azOzk8w3_AZ3hdzxnlU_45Kf2DyqwPbdzI02Zco9NZIMeta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/collect-payment/invoice/index.vue")
  },
  {
    name: "settings-billing-provider",
    path: "/settings/billing/:provider?",
    meta: {"middleware":["auth","has-a-plan"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/billing/[[provider]].vue")
  },
  {
    name: "channel-subscription-token",
    path: "/:channel()/subscription/:token()",
    meta: _91token_93ntqwxQegMbr5vU22fUIN7IfPaH0v_45rClRSgYaSxDTx8Meta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/[channel]/subscription/[token].vue")
  },
  {
    name: "collect-payment-recieved",
    path: "/collect-payment/recieved",
    meta: {"middleware":["auth","email-verified"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/collect-payment/recieved/index.vue")
  },
  {
    name: "engage-id-messages-message",
    path: "/engage/:id()/messages/:message()",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/messages/[message].vue")
  },
  {
    name: "engage-broadcasts-details-id",
    path: "/engage/broadcasts/details/:id()",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/broadcasts/details/[id].vue")
  },
  {
    name: "settings-roles-permission-id",
    path: "/settings/roles-permission/:id()",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/roles-permission/[id].vue")
  },
  {
    name: "collect-payment-reconcile",
    path: "/collect-payment/reconcile",
    meta: {"middleware":["auth","email-verified"]},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/collect-payment/reconcile/index.vue")
  },
  {
    name: "settings-roles-permission",
    path: "/settings/roles-permission",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/roles-permission/index.vue")
  },
  {
    name: "settings-roles-permission-create",
    path: "/settings/roles-permission/create",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/settings/roles-permission/create.vue")
  },
  {
    name: "collect-payment-invoice-id-preview",
    path: "/collect-payment/invoice/:id()/preview",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/collect-payment/invoice/[id]/preview.vue")
  },
  {
    name: "integrations-zoho-company-callback",
    path: "/integrations/zoho/:company()/callback",
    meta: callbackWPvxWVECVEQb_45lq1IfJCMjAW3zSz_6OgLgYzK0uFjbQMeta || {},
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/integrations/zoho/[company]/callback.vue")
  },
  {
    name: "engage-transactional-templates-create",
    path: "/engage/transactional/templates/create",
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/transactional/templates/create.vue")
  },
  {
    name: "SendReminder",
    path: "/collect-payment/reconcile/:id()/send-reminder",
    meta: { ...(send_45reminderPk0lt8_459Yyi__456qNt0QF5CAIqThLzcYkGN50o_8gnq4Meta || {}), ...{"middleware":["auth","email-verified"]} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/collect-payment/reconcile/[id]/send-reminder.vue")
  },
  {
    name: "WorkflowVersionPreview",
    path: "/engage/:id()/workflow-version-preview/:version()",
    meta: { ...(_91version_93rKee41LIuAEQg2fU6gudwOPI_454F4w07jolgaUuFGKNAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/codebuild/output/src713373481/src/dashboard/pages/engage/[id]/workflow-version-preview/[version].vue")
  }
]